/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Birthday_AndInputs */

const fr_calendar_birthday_and = /** @type {(inputs: Calendar_Birthday_AndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`et`)
};

/**

* @param {Calendar_Birthday_AndInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const calendar_birthday_and = /** @type {((inputs?: Calendar_Birthday_AndInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Birthday_AndInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_calendar_birthday_and(inputs)
});